import React from 'react';
import { useHistory } from 'react-router-dom';
import { HOMEPAGE } from '../navigation/Constants';


const CompletedProfilePage = () => {
    const history = useHistory();
    return (
        <div className="content_sec white wf-section" style={{ height: '100vh' }}>
            <div className="signup_top_info">
                <div className="signup_pict">
                    <img src="/assets/images/done_title_pict.svg" loading="lazy" alt="" />
                </div>
                <h2 className="signup_title welcome" style={{ fontSize: '1.3rem' }}>בראבו, אפשר להתחיל!</h2>
                <div>עכשיו נוכל למצוא בשבילך התאמות לפי ההעדפות שלך.</div>
                <a href="#" onClick={() => history.push(HOMEPAGE)} className="button_full welcome w-button">בואו נכיר!</a>
            </div>
        </div>
    )
}

export default CompletedProfilePage;